import { createFeatureSelector, createSelector } from "@ngrx/store";
import { accessoryFeatureKey, AccessoryState } from "./accessory.reducer";

export const selectAccessoryState =
  createFeatureSelector<AccessoryState>(accessoryFeatureKey);

export const selectAccessory = createSelector(
  selectAccessoryState,
  (state) => state
);